module.exports = __webpack_public_path__ + "img/berachain.6d907bf9.svg";